/**
 * @desc createUser
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.SysUserRpcRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/user/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
